import { useMemo } from 'react';
import { useMatches } from 'react-router-dom';
import type { OsRouteHandle, OsRouteMeta } from './osRouteMeta';

/** Resolves the deepest OS route metadata for the current location. */
export const useOsRouteMeta = (): OsRouteMeta | undefined => {
  const matches = useMatches();

  return useMemo(
    () =>
      [...matches]
        .reverse()
        .map((match) => (match.handle as OsRouteHandle | undefined)?.os)
        .find((handle): handle is OsRouteMeta => Boolean(handle)),
    [matches]
  );
};
